// extracted by mini-css-extract-plugin
export default {"SurveyRecordPhotos":"SurveyRecordPhotos_SurveyRecordPhotos__p6Fpn"};